import React from "react";
import { CopyHash, Page } from "@sscs/ui";
import { getClassName, humanReadableBytes } from "@sscs/utils";
import { getFileName, getSha256 } from "../../../../utils";
import styles from "./diffHeader.module.scss";
const getFileType = (info) => `${info.type}/${info.subtype}${info.format ? `/${info.format}` : ""}`;
const FileBlock = ({ id, label, info, align, }) => {
    const sha256 = getSha256(info);
    return (React.createElement("div", { className: getClassName(styles["file-block"], align === "right" ? styles["file-block-right"] : undefined) },
        React.createElement("strong", { className: styles["file-name"] }, getFileName(info)),
        React.createElement("small", { className: styles["file-caption"] },
            label,
            " \u00B7 ",
            getFileType(info),
            " \u00B7 ",
            humanReadableBytes(Number(info.size))),
        React.createElement("span", { className: styles.hash },
            React.createElement("span", { title: sha256 }, `${sha256.slice(0, 6)}…${sha256.slice(-6)}`),
            React.createElement(CopyHash, { id: id, sha256: sha256 }))));
};
const VerdictGlyph = ({ glyph, failed, }) => {
    if (glyph === "compare") {
        return (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
            React.createElement("path", { d: "M3 7h13M13 4l3 3-3 3" }),
            React.createElement("path", { d: "M17 13H4M7 10l-3 3 3 3" })));
    }
    return React.createElement("span", { className: styles.glyph }, failed ? "≠" : "=");
};
const DiffHeader = ({ id, title, statusLabel, failed, description, glyph, files, }) => {
    const [left, right] = files;
    return (React.createElement(React.Fragment, null,
        React.createElement(Page.Header, { id: id, title: title, details: [
                React.createElement("span", { key: "verdict", className: failed ? styles["sentence-fail"] : undefined }, description),
            ] }),
        React.createElement("div", { className: getClassName(styles.comparison, failed ? styles["comparison-fail"] : undefined) },
            React.createElement(FileBlock, { ...left, align: "right" }),
            React.createElement("div", { className: styles.verdict },
                React.createElement("div", { className: getClassName(styles.circle, failed ? styles["circle-fail"] : styles["circle-pass"]) },
                    React.createElement(VerdictGlyph, { glyph: glyph, failed: failed })),
                statusLabel),
            React.createElement(FileBlock, { ...right }))));
};
export default DiffHeader;
//# sourceMappingURL=DiffHeader.js.map